import { OrganizationRole } from '@/entities/session';
import { Select } from '@/shared/ui';

const OPTIONS: { value: OrganizationRole; label: string }[] = [
  {
    label: 'Admin',
    value: OrganizationRole.ADMIN,
  },
  {
    label: 'User',
    value: OrganizationRole.USER,
  },
];

interface Props {
  value: OrganizationRole;
  onChange: (value: OrganizationRole) => void;
}

export function RoleSelect({ value, onChange }: Props) {
  return (
    <Select
      selectProps={{
        MenuProps: {
          slotProps: {
            root: {
              sx: {
                zIndex: 1301,
              },
            },
          },
        },
      }}
      label="Role"
      value={value}
      options={OPTIONS}
      onChange={onChange}
    />
  );
}
